import { adminHttpClient } from '../commons/adminHttpClient'
import PagedFilter from '../commons/pagedFilter'

const getEmployeeBenefitParticipationStatusHistory = (filter: PagedFilter, id: string): Promise<any> => {
    filter = filter || {
      pageNumber: 1,
      pageSize: 10,
    }
  
    return adminHttpClient.get(`/Companies/EmployeeBenefitParticipationStatusHistory`, {
      ...filter,
      employeeId: id,
    })
  }
  
  export default getEmployeeBenefitParticipationStatusHistory